import React, { useRef, useState } from 'react'
import moment from 'moment'
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from 'react-sortable-hoc'
import WordCount from '../../../../components/Images/WordCount'
import { getDate } from '../../../../components/TextEditor/helper'
import { put } from '../../../../lib/api'
import progress from './progress.gif'
import {
  ChapterHolder,
  Container,
  InfoHolder,
  Calendar,
  ChapterCount,
  ButtonWrapper,
  EyeIcon,
  DragHandler,
  ChapterTitleContainer,
  OverlayChapterDiv,
} from '../styles'
import GenericError from '../../../../components/GenericError'
import MessagePopup from '../../../../components/MessagePopup'
import ReorderIcon from '../../../../components/Images/Reorder'
import DragIcon from '../../../../components/Images/DragHandle'
import { Button, Text } from '../../../../designSystem'
import { menuItemObj } from '../../../../components/PrivatePage'
import { VellipContainer, VellipIcon } from '../styles'
import { Dustbin, ChapterOptionsBox, Option } from './commonStyles'
import { Popup } from '../../../../components/Popup'
import CalendarClock from '../../../../components/Images/CalendarClock'
import Tooltip from '../../../../CustomTooltip'
import { numFormatter } from '../../../../lib/utils'
import AudioModule from './Sections/audioModule'
import Loader from '../../../../components/Loader'
import { handleNewEventLog } from '../../../../lib/utils/events'
import { deleteChapterUIDs } from '../../../Home/constants'

const isMobile = window.screen.width < 600

const DragHandle = SortableHandle(DragIcon)

const SortableItem = SortableElement(
  ({ chapter, index, dragHandle, ...props }) => {
    const [hoverPublished, setHoverPublished] = useState(-1)
    const [isChapterOptionsShown, toggleShowChapterOptions] = useState(false)
    const [showProgressPopup, toggleProgressPopup] = useState(false)
    const isUgcBook = props?.bookDetails?.is_novel === 2 
    const isDeleteOptionShown = isUgcBook ? (deleteChapterUIDs?.includes(localStorage.getItem('uid')) &&  chapter?.audio_status === 'completed' && !chapter?.deletion_request_active) : true
    const handleVellipClick = (e) => {
      e.stopPropagation()
      toggleShowChapterOptions(!isChapterOptionsShown)
    }
    const handleDeleteClick = (e, mobile) => {
      handleNewEventLog(
        'novels',
        'novels_chapter_delete_clicked',
        {
          route: window.location.pathname + window.location.search,
          button: 'delete_chapter',
          entity_id: chapter.chapter_id,
          entity_type: 'chapter',
        },
        props.user,
        props.bookDetails
      )
      if (mobile) toggleShowChapterOptions(false)
      props.handleDelete(e, 'published', chapter.chapter_id)
    }

    const getToolTipText = () => {
      return (
        <>
          {props?.bookDetails?.is_novel !== 2
            ? `IST ${moment(chapter.publish_time).format(
                'HH:mm A MMM DD,YYYY '
              )}`
            : `EST ${moment(chapter.publish_time)
                .utcOffset(-4)
                .format('HH:mm A MMM DD,YYYY ')}`}
          <br />
          (UTC+0{' '}
          {moment
            .utc(chapter.publish_time, 'YYYY-MM-DD HH:mm')
            .format('HH:mm A MMM DD,YYYY ')}
          )
        </>
      )
    }

    const handleChapterClick = () => {
      if (isDeletionRequestActive) return
      if (chapter?.audio_status === 'pending') toggleProgressPopup(true)
      else {
        handleNewEventLog(
          'novels_page',
          'novels_chapter_selected',
          {
            route: window.location.pathname + window.location.search,
            module_name: 'particular_chapter_selected',
            entity_id: chapter.chapter_id,
            entity_type: 'chapter',
          },
          props.user,
          props.bookDetails
        )
        props.history.push(
          `${menuItemObj.novels}/edit-chapter/${props.id}?chapter_id=${chapter.chapter_id}`
        )
      }
    }
    const isScheduled = new Date(chapter.publish_time) - new Date() > 0
    const isDeletionRequestActive = chapter?.deletion_request_active
    return (
      <>
        <Popup
          className="bottom-sheet no-padding"
          show={isChapterOptionsShown}
          close={() => toggleShowChapterOptions(false)}
        >
          <ChapterOptionsBox>
            <Option onClick={(e) => handleDeleteClick(e, true)}>
              <Dustbin />
              <Text variant="title" fontWeight="r">
                Delete
              </Text>
            </Option>
          </ChapterOptionsBox>
        </Popup>
        <Popup
          show={showProgressPopup}
          close={() => toggleProgressPopup(false)}
          renderActions={
            <>
              <button
                className="action-button primary"
                type="button"
                onClick={() => toggleProgressPopup(false)}
              >
                Okay
              </button>
            </>
          }
        >
          <div className="form-error">
            <img
              src={progress}
              width={24}
              height={24}
              style={{ marginRight: '8px' }}
            />
            <Text variant="heading">Audio Creation In Progress</Text>
          </div>
          <div>
            <Text>
              Your text is in the process of being converted to audio, which can
              take up to 2 hours. Kindly make chapter updates after this
              conversion is complete. Thank you for your patience!
            </Text>
          </div>
        </Popup>

        <ChapterHolder
          key={chapter.chapter_id}
          onMouseOver={() => setHoverPublished(index)}
          onMouseLeave={() => setHoverPublished(-1)}
          disabled={isDeletionRequestActive}
        >
          {isDeletionRequestActive && <OverlayChapterDiv />}
          {!isDeletionRequestActive && index === hoverPublished ? (
            <DragHandler>{dragHandle()}</DragHandler>
          ) : (
            <ChapterCount disable={isDeletionRequestActive}> {chapter.natural_sequence_number}</ChapterCount>
          )}
          <Container onClick={handleChapterClick}>
            <ChapterTitleContainer disable={isDeletionRequestActive} width={`${window.screen.width - 150}px`}>
              {chapter.chapter_title}
            </ChapterTitleContainer>
            {isDeletionRequestActive ? (
              <Text variant="caption" mt={4} color="rgb(98, 102, 124,0.4)">
                Chapter deletion request under review
              </Text>
            ) : (
              <InfoHolder>
                <EyeIcon />
                <Text variant="caption" ml="4px" mr="16px">
                  {numFormatter(chapter.total_views || 0)}
                </Text>
                {isScheduled ? <CalendarClock color="#ae8701" /> : <Calendar />}
                <Tooltip content={getToolTipText()} direction="bottom">
                  <Text
                    variant="caption"
                    ml="4px"
                    mr="16px"
                    width="max-content"
                    color={isScheduled ? 'rgba(174,135,1)' : 'rgba(13, 21, 54, 0.65)'}
                  >
                    {moment(chapter.publish_time).format('DD MMM YYYY')}
                  </Text>
                </Tooltip>
                <WordCount />
                <Text variant="caption" ml="4px" mr="16px">
                  {chapter.word_count}
                </Text>
              </InfoHolder>
            )}
          </Container>
          <>
            {!isDeletionRequestActive &&
              props?.bookDetails?.is_novel === 2 &&
              (chapter?.audio_status === 'pending' ? (
                <img
                  src={progress}
                  alt="Loading..."
                  width="24px"
                  height="24px"
                />
              ) : (
                chapter?.audio_status === 'completed' && (
                  <AudioModule audioUrl={chapter?.audio_url} />
                )
              ))}

            {!isMobile && isDeleteOptionShown && (
              <ButtonWrapper onClick={handleDeleteClick}>
                <Button variant="semiFillDanger">Delete</Button>
              </ButtonWrapper>
            )}
            {isMobile && isDeleteOptionShown && (
              <VellipContainer>
                <VellipIcon onClick={handleVellipClick} />
              </VellipContainer>
            )}
          </>
        </ChapterHolder>
      </>
    )
  }
)

const SortableList = SortableContainer(({ items, ...props }) => {
  return (
    <ul>
      {items.map((chapter, index) => (
        <SortableItem
          key={`item-${chapter.chapter_id}`}
          index={index}
          chapter={chapter}
          dragHandle={() => <DragHandle />}
          {...props}
        />
      ))}
    </ul>
  )
})

function SortableComponent(props) {
  const [moveIndexes, setMoveIndexes] = useState([0, 0])
  const [isWarningShown, setWarning] = useState(false)
  const [apiError, toggleApiError] = useState(false)
  const [apiErrorMsg, setApiErrorMsg] = useState({})

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex === newIndex) return
    setMoveIndexes([oldIndex, newIndex])
    setWarning(true)
  }

  const handleMove = () => {
    const [oldIndex, newIndex] = moveIndexes
    const { chapters, id } = props
    const EpisodeObjFrom = chapters[oldIndex]
    const EpisodeObjTo = chapters[newIndex]
    const sequenceFrom =
      EpisodeObjFrom.seq_number || EpisodeObjFrom.chapter_details.seq_number
    const sequenceTo =
      EpisodeObjTo.seq_number || EpisodeObjTo.chapter_details.seq_number
    const api = '/content_api/book.sequence_show_episodes?is_novel=1'
    const data = {
      prev_seq: sequenceFrom,
      next_seq: sequenceTo,
    }
    data['book_id'] = id
    data['is_chapter'] = true
    data['view'] = 'dashboard'

    put(api, {
      data,
    })
      .then(() => {
        setWarning(false)
        props.updateChaptersList()
      })
      .catch((error) => {
        setWarning(false)
        setApiErrorMsg({})
        throw error
      })
  }

  return (
    <>
      <GenericError
        show={apiError}
        title={apiErrorMsg.title}
        message={apiErrorMsg.message}
        onClose={() => toggleApiError(false)}
      />
      <MessagePopup
        show={isWarningShown}
        renderIcon={<ReorderIcon />}
        onClose={() => setWarning(false)}
        onConfirm={handleMove}
        cancelText="Cancel"
        confirmText={'Change sequence'}
        messageTitle="Confirm Sequence changes?"
        messageBody={
          'Are you sure you want to change the sequence of this episodes, this will result in changing sequence of other episodes as well.'
        }
      />
      <SortableList
        items={props.chapters}
        {...props}
        lockAxis="y"
        onSortEnd={onSortEnd}
        useDragHandle
        // pressDelay={200}
      />
    </>
  )
}

export { SortableComponent }
